import React, {useEffect, useRef} from "react";

export default function NotFoundPage() {

    const isMountedRef = useRef(false);

    useEffect(() => {
        // if (!isMountedRef.current) {
        //     isMountedRef.current = true;
        //     const payload = {
        //         level: "INFO",
        //         timestamp: new Date().toISOString(),
        //         pageName: LogContent.NOT_FOUND_PAGE,
        //         message: LogContent.NOT_FOUND_PAGE_MESSAGE
        //     };
        //
        //     submitWebSheetLogCollection(payload)
        //         .then(() => {
        //             console.log('Log submitted successfully');
        //         })
        //         .catch(error => {
        //             console.error('Error submitting log:', error);
        //         });
        // }
    }, []);

    return (
        <div>
            <h1>Forbidden</h1>
            <p>You don't have permission to access this resource. Please contact the service provider.</p>
        </div>
    );
}
